var __default__ = {card:'m_9dc8ae12'};
export default __default__;